/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { CustomDateFormatService } from '../../../../../services/custom-date-format/custom-date-format.service';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-workflow-property',
  standalone: true,
  templateUrl: './workflow-property.component.html',
  styleUrls: ['./workflow-property.component.scss']
})
export class WorkflowPropertyComponent implements OnChanges {
  @Input() label: string = '';
  @Input() text: string | undefined = '';
  @Input() version: number | undefined;
  @Input() date: string | Date | undefined;
  
  formattedDate: string = '';

  constructor(private dateFormatService: CustomDateFormatService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['date'] && this.date) {
      // Convert to string if it's a Date object
      const dateString = this.date instanceof Date ? this.date.toISOString() : this.date;
      this.formattedDate = this.dateFormatService.formatDate(dateString);
    }
  }
}
